// extracted by mini-css-extract-plugin
export default {"outerContainer":"TradingModuleWrapper_outerContainer__lOBsk","container":"TradingModuleWrapper_container__M9MSs","header":"TradingModuleWrapper_header__UJ7JP"};